import { withRouter } from 'react-router';
import { withUser } from 'components/queries/GetUserQuery';

import BusinessBenefitUpgradeCta from './BusinessBenefitUpgradeCta';

export default withRouter(withUser(BusinessBenefitUpgradeCta));
